import React from 'react';
import {Route, Switch, useRouteMatch} from "react-router-dom";

// Availabilities Pages
import NotifyAbsence from "./NotifyAbsence";
import MainPage from "./MainPage";

const Availabilities = () => {
   const match = useRouteMatch();

   return <Switch>
      <Route exact path={`${match.path}/notify_absence`} component={NotifyAbsence}/>

      <Route exact path={`${match.path}`} render={(props) => <MainPage {...props} />}/>
   </Switch>
}

export default Availabilities;